module.exports = __webpack_public_path__ + "static/media/ArrowDown.658e63a3.svg";